<!--@format-->
<template>
    <div class="journey-delay-step-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Delay</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="isLoading">
                    <loading-screen-svg />
                </div>
                <div v-else>
                    <label>How long?</label>
                    <div class="input-fields">
                        <app-input v-model="step.delayDuration" :type="'number'" />
                        <duration-dropdown v-model="step.delayDurationType" />
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save" :disabled="isLoading" :loading="isLoading"
                        >Save</app-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const DurationDropdown = () => import('@/components/common/duration-dropdown');
const AppInput = () => import('@/components/common/app-input');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'journey-delay-step-widget',

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    components: {
        'app-button': AppButton,
        'app-input': AppInput,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
        'duration-dropdown': DurationDropdown,
    },

    data() {
        return {
            isLoading: true,
            step: {
                id: null,
                delayDuration: 0,
                delayDurationType: null,
            },
        };
    },

    methods: {
        save() {
            this.isLoading = true;

            this.step.delayDuration = parseInt(this.step.delayDuration);

            if (this.step.id) {
                this.patchStep();
            } else {
                this.postStep();
            }
        },

        patchStep() {
            var changes = [
                {
                    name: 'DelayDuration',
                    value: this.step.delayDuration,
                },
                {
                    name: 'DelayDurationType',
                    value: this.step.delayDurationType,
                },
            ];

            this.$api
                .patch(`/api/JourneySteps/${this.step.id}`, changes)
                .then(() => {
                    this.$helpers.showSuccessNotification('Step successfully saved.');
                    EventBus.$emit(`journey-step:update`, this.step);
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while saving your step.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        postStep() {
            var request = {
                journeyId: null,
                delayDuration: this.step.delayDuration,
                delayDurationType: this.step.delayDurationType,
            };

            this.$api
                .post(`/api/JourneySteps`, request)
                .then((response) => {
                    this.step.id = response.data.Id;

                    this.$helpers.showSuccessNotification('Step successfully saved.');
                    EventBus.$emit(`journey-step:update`, this.step);
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while saving your step.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getStep() {
            this.$api
                .get(`/service/JourneySteps?$filter=Id eq ${this.step.id}`)
                .then((response) => {
                    var responseValue = response.data.value[0];

                    this.step.delayDuration = responseValue.DelayDuration;
                    this.step.delayDurationType = responseValue.DelayDurationType;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while fetching your step.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },

    created() {
        if (this.widget.options.stepId) {
            this.step.id = this.widget.options.stepId;
            this.getStep();
        } else {
            this.isLoading = false;
        }
    },
};
</script>

<style>
.journey-delay-step-widget.widget .widget-contents-container .widget-header {
    background: #ff5a6f;
    background: transparent linear-gradient(85deg, #ff5a6f 0%, #f2cf80 100%);
}

.journey-delay-step-widget .content-wrapper {
    padding: 0px;
}

.journey-delay-step-widget .content-wrapper .input-fields {
    display: flex;
    align-items: flex-end;
}

.journey-delay-step-widget .content-wrapper .input-fields .app-input {
    margin-right: 20px;
}

.journey-delay-step-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.journey-delay-step-widget .cancel-btn:hover {
    background: #e9e9ef;
}

.journey-delay-step-widget .widget-contents-container .loading-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-left: 0;
}
</style>
